import OffersList from '@/components/OffersList'
import { offersListUpdated } from '@/events'
import { OffersListRequest } from '@/modules/api'
import QueryString from '@/utils/QueryString'

function updateNumberOfOffersFound (count) {
  const info = document.querySelector('.listing-options__result-info')
  if (info) {
    if (count === -1) {
      info.innerHTML = '<p>Wyszukuję...</p>'
    } else if (count > 0) {
      info.innerHTML = `<p>Znaleziono <span class="listing-options__result-count">${count}</span> ofert spełniających kryteria</p>`
    } else {
      info.innerHTML = '<p>Brak ofert spełniajacych kryteria</p>'
    }
  }
}

offersListUpdated.subscribe((e, { offersCount } = e.detail) => {
  updateNumberOfOffersFound(offersCount)
})

export const valueToSortOrder = {
  0: { field: 'price', direction: 'asc' },
  1: { field: 'price', direction: 'desc' },
  2: { field: 'name', direction: 'asc' },
  3: { field: 'name', direction: 'desc' },
  4: { field: 'standard', direction: 'asc' },
  5: { field: 'standard', direction: 'desc' },
}

export const valueToPriceType = {
  '1': 'person',
  '2': 'group',
}

export const valueToViewTypeMap = {
  '1': 'list',
  '2': 'tiles',
  '3': 'map',
}

function dataForFirstLoadOfOffersListExists () {
  const dataSourceDiv = document.querySelector('.load-offers[data-first-load]')
  return dataSourceDiv && dataSourceDiv.dataset.firstLoad
}

export function init () {
  if (!dataForFirstLoadOfOffersListExists()) {
    log.debug('Element with class "load-offers" and a valid "data-first-load" attribute not found - skipping initialization of offers list')
    return
  }

  document.querySelectorAll('.offer-list').forEach(el => {
    const initialUrlForLoadingData = OffersListRequest.getInitialUrl()
    const shouldSetListingFilters = OffersListRequest.shouldSetListingFiltersInSearch()
    const initialViewType = new QueryString().get('TypeViewListing') || 'list'
    //
    // This should take the initial sort order (including direction) and price grouping from query string
    // but it is overriden with values from currently broken component sitting right above the listing of offers
    // It is the component displaying search order, price grouping and view type selectors.
    // Therefore, for the time being, the values are initialized with consts
    //
    // const sort = Number(new QueryString().get('SortOption'))
    // const initialOrderBy = valueToSortOrder[sort % 5].field
    // const initialDirection = valueToSortOrder[sort % 5].direction
    // const initialPriceType = sort >= 5 ? 'group' : 'person'
    const initialOrderBy = 'price'
    const initialDirection = 'asc'
    const initialPriceType = 'person'
    new OffersList({ el, propsData: { initialUrlForLoadingData, shouldSetListingFilters, initialViewType, initialPriceType, initialOrderBy, initialDirection } })
  })
}



// WEBPACK FOOTER //
// ./src/modules/offersList.js